import React from "react";
import { View, Pressable, StyleSheet } from "react-native";
import { FileText } from "lucide-react";
import CustomText from "../../../common/general/CustomText/CustomText";

export interface AssignmentSuggestion {
  id: string;
  title?: string | null;
  due_date?: string | null;
}

interface AssignmentSuggestionCardProps {
  assignment: AssignmentSuggestion;
  onPress: (assignment: AssignmentSuggestion) => void;
  isHovered?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export const AssignmentSuggestionCard: React.FC<AssignmentSuggestionCardProps> = ({
  assignment,
  onPress,
  isHovered = false,
  onMouseEnter,
  onMouseLeave,
}) => {
  return (
    <Pressable
      style={[styles.assignmentItem, isHovered && styles.assignmentItemHovered]}
      onPress={() => onPress(assignment)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}>
      <View style={styles.assignmentContent}>
        <View style={styles.assignmentTitleRow}>
          <FileText size={20} color="#3e68fe" style={styles.assignmentIcon} />
          <CustomText
            text={assignment.title || "Untitled Assignment"}
            useTranslationText={false}
            style={styles.assignmentName}
            numberOfLines={1}
          />
        </View>
        {assignment.due_date && (
          <CustomText
            text={`Due ${new Date(assignment.due_date).toLocaleDateString(undefined, {
              weekday: "short",
              month: "short",
              day: "numeric",
            })}`}
            useTranslationText={false}
            style={styles.assignmentDate}
          />
        )}
      </View>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  assignmentItem: {
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderRadius: 16,
    marginBottom: 8,
    cursor: "pointer",
    borderWidth: 1,
    borderColor: "#EAECF0",
  },
  assignmentItemHovered: {
    backgroundColor: "#E6EBFF",
    borderColor: "#6788FE",
  },
  assignmentContent: {
    flex: 1,
  },
  assignmentTitleRow: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 4,
  },
  assignmentIcon: {
    marginRight: 8,
  },
  assignmentName: {
    fontSize: 14,
    color: "#101828",
    fontWeight: "500",
    flex: 1,
  },
  assignmentDate: {
    fontSize: 12,
    color: "#667085",
    marginLeft: 28,
  },
});
